import { black, white, red, darkTeal, teal, green, limeGreen, purple, magenta, grey100, grey200, grey300, grey400, grey500, grey600, grey700, grey800 } from 'dma-ui-kit';

export const colorMap = {
    'black': black, 'darkTeal': darkTeal, 'green': green, 'grey100': grey100, 
    'grey200':grey200, 'grey200': grey200, 'grey300': grey300, 'grey400': grey400, 
    'grey500':grey500, 'grey600': grey600, 'grey700': grey700, 'grey800': grey800,
    'limeGreen':limeGreen, 'magenta': magenta, 'purple': purple, 'red': red, 
    'teal': teal, 'white': white
};